





























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

interface DealMethod {
  title: string;
  value: string;
}

interface RuleRow {
  id: string;
  talkResult: string;
  handleMethod: string;
  delayDays: number | "";
}

interface ResultStrategy {
  title: string;
  oper: "==";
  value: string;
  action: number[];
  dncDay: number | "";
}

@Component
export default class RuleStrategyConfig extends Vue {
  /* ========= props ========= */

  @Prop({ default: "" }) readonly value!: string;
  @Prop({ default: () => [] }) readonly talkresultList!: any[];
  @Prop({ default: () => [] }) readonly dealmethodList!: DealMethod[];
  @Prop({ default: "" }) readonly initResultStrategies!: string;
  private isInternalUpdate = false;

  /* ========= data ========= */

  ruleList: RuleRow[] = [];

  /* ========= watch ========= */

  /** 初始化 & 回显 */
  @Watch("value", { immediate: true })
  onValueChange(val: string) {
    // ⭐ 子组件自己触发的更新，直接忽略
    if (this.isInternalUpdate) return;

    if (!val) {
      this.ruleList = [this.createRow()];
      return;
    }

    try {
      const parsed: ResultStrategy[] = JSON.parse(val);

      this.ruleList = parsed.length
        ? parsed.map((item) => ({
            id: this.genRowId(),
            talkResult: item.value,
            handleMethod: item.action?.[0]?.toString() || "",
            delayDays: item.dncDay || "",
          }))
        : [this.createRow()];
    } catch {
      this.ruleList = [this.createRow()];
    }
  }

  private genRowId(): string {
    return `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  }

  /** 同步父组件 */
  @Watch("ruleList", { deep: true })
  onRuleListChange() {
    this.emitResult();
  }
  get normalizedTalkResultList() {
    return this.talkresultList.map((item: any) => {
      if (typeof item === "string") {
        return {
          label: item,
          value: item,
        };
      }
      return {
        label: item.label,
        value: item.value,
      };
    });
  }

  /* ========= methods ========= */

  createRow(): RuleRow {
    return {
      id: this.genRowId(),
      talkResult: "",
      handleMethod: "",
      delayDays: "",
    };
  }

  addRow() {
    this.ruleList.push(this.createRow());
  }

  removeRow(index: number) {
    this.ruleList.splice(index, 1);
  }

  onMethodChange(row: RuleRow) {
    if (row.handleMethod !== "2") {
      row.delayDays = "";
    }
  }

  getTalkResultOptions(currentIndex: number) {
    const selectedValues = this.ruleList
      .map((row, index) => (index !== currentIndex ? row.talkResult : null))
      .filter(Boolean);

    return this.normalizedTalkResultList.map((item) => ({
      label: item.label,
      value: item.value,
      disabled: selectedValues.includes(item.value),
    }));
  }

  emitResult() {
    this.isInternalUpdate = true;

    const result = this.ruleList
      .filter((r) => r.talkResult && r.handleMethod)
      .map((r) => ({
        title: "Talk Result",
        oper: "==",
        value: r.talkResult,
        action: [Number(r.handleMethod)],
        // 条件添加 dncDay
        ...(r.handleMethod === "2" ? { dncDay: Number(r.delayDays) || 1 } : {})
      }));

    this.$emit("input", JSON.stringify(result));

    this.$nextTick(() => {
      this.isInternalUpdate = false;
    });
  }
}
